import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=22bdf745"
import script from "./connect.vue?vue&type=script&lang=js"
export * from "./connect.vue?vue&type=script&lang=js"
import style0 from "./connect.vue?vue&type=style&index=0&id=22bdf745&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports